import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  I18n,
  Icon,
} from 'components';

import Attachment from '../Attachment';

import { convertAPIDateToUIDate } from '../../common';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const fixMessageText = (input) => input
  .replace(/;\s*$/, '')
  .replace(
    '<a href="">Перейти в настройки</a>',
    ' <a href="settings">Перейти в настройки</a>',
  );

const MessageDetails = ({
  id,
  text = '',
  title,
  attachment,
  comments,
  isHelpdesk,
}) => (
  <>
    <div className={cx('arrow')} />
    <div className={cx('content')}>
      <div className={cx('messageId')}>
        {`ID ${id}`}
      </div>
      {comments
        ? (
          <>
            {comments.question && (
              <div className={cx('commentWrapper')}>
                <div>
                  {isHelpdesk ? '' : comments.question.comment}
                </div>
                <div
                  className={cx('commentDate')}
                >
                  {convertAPIDateToUIDate(comments.question.date)}
                </div>
              </div>
            )}
            {comments.answer && (
              <div>
                <div className={cx('answerTitleWrapper')}>
                  <Icon className={cx('chatIcon')} name="chat" />
                  <I18n className={cx('answerTitle')} path="messages.supportAnswer" />
                </div>
                <div className={cx('commentWrapper', 'answer')}>
                  <div>
                    {comments.answer.comment}
                  </div>
                  <div
                    className={cx('commentDate')}
                  >
                    {convertAPIDateToUIDate(comments.answer.date)}
                  </div>
                </div>
              </div>
            )}
          </>
        )
        : (
          <>
            <div dangerouslySetInnerHTML={{ __html: fixMessageText(text) }} />
            {attachment && (
              <Attachment
                {...attachment}
                title={title}
                id={id}
              />
            )}
          </>
        )}
    </div>
  </>
);

MessageDetails.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  isHelpdesk: PropTypes.bool,
  text: PropTypes.string,
  title: PropTypes.string,
  attachment: PropTypes.object,
  comments: PropTypes.shape({
    question: PropTypes.object,
    answer: PropTypes.object,
  }),
};

export default MessageDetails;
